import type { QueryClientConfig, QueryKey } from "@tanstack/react-query";
import superjson from "superjson";

export function hashApiQueryKey(queryKey: QueryKey): string {
  return JSON.stringify(superjson.serialize(queryKey));
}

export function getApiQueryClientDefaults(): NonNullable<
  QueryClientConfig["defaultOptions"]
> {
  return {
    queries: {
      queryKeyHashFn: hashApiQueryKey,
    },
    dehydrate: {
      serializeData: (data) => superjson.serialize(data),
    },
    hydrate: {
      deserializeData: (data) =>
        superjson.deserialize(
          data as Parameters<typeof superjson.deserialize>[0],
        ),
    },
  };
}
